import React from 'react';
import { Level } from '../../types/level';
import { LevelWidth, LevelHeight } from '../../types/levelUtils';
import { DefaultStyles } from '../canvas-level-render/types';
import './svg-card-render.css';

const RenderScale: number = 20;
const OffsetX: number = 4;
const OffsetY: number = -4;

interface Props {
  level?: Level;
  width?: number;
  height?: number;
  placeholderText?: string;
  onPlaceholderClick?: () => void;
}

interface Point {
  x: number;
  y: number;
  ch: string;
}

const SVGCardRenderComponent = ({ level, placeholderText, onPlaceholderClick }: Props) => {
  const points = [] as Point[];
  if (level) {
    level.words.forEach((word) => {
      Array.from(word.word).forEach((ch, chIndex) => {
        points.push({
          x: word.metadata.x + (word.metadata.isVertical ? 0 : 1) * chIndex,
          y: word.metadata.y + (word.metadata.isVertical ? 1 : 0) * chIndex,
          ch: ch,
        });
      });
    });
  }

  return (
    <div
      className={`svg-card ${!level ? 'empty' : ''} ${!level && onPlaceholderClick ? 'svg-card-clickable' : ''}`}
      onClick={!level ? onPlaceholderClick : undefined}
      role={!level && onPlaceholderClick ? 'button' : undefined}
    >
      {!level && placeholderText && <div className="svg-card-placeholder">{placeholderText}</div>}
      {level && (
        <svg
          version="1.1"
          width={LevelWidth(level) * RenderScale}
          height={LevelHeight(level) * RenderScale}
          xmlns="http://www.w3.org/2000/svg"
        >
          {points.map((w, ind) => {
            return (
              <g key={ind}>
                <rect
                  x={w.x * RenderScale}
                  y={w.y * RenderScale}
                  width={RenderScale}
                  height={RenderScale}
                  stroke={DefaultStyles.StrokeColor}
                  fill={DefaultStyles.FillValidColor}
                />
                <text x={w.x * RenderScale} y={(w.y + 1) * RenderScale} dx={OffsetX} dy={OffsetY}>
                  {w.ch}
                </text>
              </g>
            );
          })}
        </svg>
      )}
    </div>
  );
};

export default SVGCardRenderComponent;
